import React from 'react';

import Button from '../../../../Controls/Button';
import { $l } from '../../../../../locales';

import css from './style.module.scss';

interface Props {
  isSubmitDisabled: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const MobileFooterActions = ({ isSubmitDisabled, onClose, onSubmit }: Props) => {
  return (
    <div className={css.mobileFooterActions}>
      <div className={css.mobileFooterActions__wrapper}>
        <Button
          padding="0-26"
          variant="primary-outlined"
          onClick={onClose}
          text={$l('CONTACT_US.CANCEL')}
        />
        <Button
          padding="0-26"
          isDisabled={isSubmitDisabled}
          onClick={onSubmit}
          text={$l('CONTACT_US.SEND')}
        />
      </div>
    </div>
  );
};

export default MobileFooterActions;
